<template>
  <div class="w-100 center tc" :class="[ mobile ? 'banner2-mobile' : 'banner2' ]">
      <div class="f1-ns tc center v-mid f2 b ">
        <div class="pt5">The ProSource Difference</div>
        <div class="fw3 f3 pa3 mt5-ns mt4 white tracked">
          <div class="dib w-25-ns w-100 mv2">
            <div class="dt bubble center" >
              <div class="dtc v-mid ph2">
                <div class="w-40 tc center"><img class="icon" src="../../assets/house.png"/></div>
                Family Owned
                <div class="f5 fw6 mt3 tc">we treat all our customers like partners, providing the best customer service</div>
                </div>
            </div>
          </div>
          <div class="dib w-25-ns w-100 mv2">
            <div class="dt bubble center" >
              <div class="dtc v-mid ph2">
                <div class="w-30 tc center"><img class="icon" src="../../assets/contractor.png"/></div>
                Built for Contractors
                <div class="f5 fw6 mt3 tc">we carry a wide variety of commercial and residential products</div>
              </div>
            </div>
          </div>
          <div class="dib w-25-ns w-100 mv2">
            <div class="dt bubble center" >
              <div class="dtc v-mid ph2">
                <div class="w-40 tc center"><img class="icon" src="../../assets/nation.png"/></div>
                National Distributor
                <div class="f5 fw6 mt3 tc">we ship all our products nationwide with record turnaround times</div>
              </div>
            </div>
          </div>
          <div class="dib w-25-ns w-100 mv2">
            <div class="dt bubble center" >
              <div class="dtc v-mid ph2">
                <div class="w-40 tc center"><img class="icon" src="../../assets/truck.png"/></div>
                Next Day service
                <div class="f5 fw6 mt3 tc">we stock all the insulation projects you need to get the job done</div>
                </div>
            </div>
          </div>
        </div>

        <div class="center w-40-ns w-100 mt4">
          <div class="f2-ns f3 b tracked pb4">a proud partner </div>
            <div class="dt center" >
              <div class="dtc sustainable v-mid ph2 pa2">
                <!-- <div class="w-100-ns w-80 center pa2"><img class="" src="../../assets/sustainable.png"/></div> -->
                <div class="w-100-ns w-100 center pa2"><img class="" src="../../assets/logos-color/certainteed.png"/></div>
              </div>
            </div>
        </div> 
    </div>
  </div>
</template>

<script>
import Trust from './trust'
export default {
  name: 'Difference',
  props: ['info', 'mobile'],
  components: { Trust }
};
</script>

<style scoped>
.banner2 {
  background: linear-gradient(8deg, #F7F7F9 25%, transparent 25%, transparent), linear-gradient(-8deg, #F7F7F9 25%, transparent 25%, transparent), 
  linear-gradient(0deg, transparent 75%, #fff 75%), linear-gradient(-0deg, transparent 75%, #fff 75%);
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.banner2-mobile {
   background: linear-gradient(45deg, #F7F7F9 25%, transparent 25%, transparent), linear-gradient(-45deg, #F7F7F9 25%, transparent 25%, transparent), 
  linear-gradient(45deg, transparent 75%, #fff 75%), linear-gradient(-45deg, transparent 75%, #fff 75%);
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.bubble {
  font-weight: bold;
  color: black;
  background: white;
  border: #efeff3 2px solid;
  height: 270px;
  width: 270px;
}
.saturate { filter: saturate(3); }
.grayscale { filter: grayscale(100%); }
.contrast { filter: contrast(160%); }
.brightness { filter: brightness(0.25); }
.blur { filter: blur(3px); }
.invert { filter: invert(100%); }
.sepia { filter: sepia(100%); }
.huerotate { filter: hue-rotate(180deg); }
.rss.opacity { filter: opacity(50%); }

.bubble .icon {
  /* -webkit-filter: invert(100%); */
}

.sustainable {
  /* background: #F7F7F9; */
  /* border-radius: 50%; */
  min-width: 268px;
}
</style>